module.exports = __webpack_public_path__ + "images/767589c60ff20d31497f99617f9447d0.jpg";